module.exports = {" _key":"@dojo/widgets/dialog","underlay":"dialog-m__underlay__2-349","main":"dialog-m__main__rrvnQ"};